import { useMemo } from 'react'

import { TicketsResponse } from 'modules/Monitoring/types'

export const useTicketResponseData = (ticketsResponse?: TicketsResponse) => {
  return useMemo(() => {
    if (!ticketsResponse) {
      return {
        tickets: [],
        ticketCount: 0,
      }
    }
    if ('items' in ticketsResponse) {
      return {
        tickets: ticketsResponse.items,
        ticketCount: ticketsResponse.count,
      }
    }

    return {
      tickets: ticketsResponse,
      ticketCount: ticketsResponse.length,
    }
  }, [ticketsResponse])
}
